import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type ChangePasswordDTO = {
    currentPassword:string;
    newPassword:string
}
type ChangePasswordResponse = object
export const ChangeUserPassword = async (payload: ChangePasswordDTO): Promise<ChangePasswordResponse> => {
    try {
        const response = await axios.patch(`/student/s/changePassword`, payload);
            return { data: response.data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};